<template>
  <div v-if="boo_modal" class="modal fade show" style="display: block">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" @click="closeModal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <CRow>
            <CCol sm="12" xs="12" md="4" lg="4" xl="4">
              <CInput
                label="Stock disponible"
                type="text"
                v-model="stock.stock"
                disabled
              ></CInput>
            </CCol>
            <CCol sm="12" xs="12" md="4" lg="4" xl="4">
              <CInput
                label="Stock a deslozar"
                type="text"
                v-model="deslozar.quantity"
                @keyup="mtdValidStock"
              ></CInput>
              <span v-if="!valid" style="color: red; font-size: 12px">
                Stock insuficiente
              </span>
            </CCol>
            <CCol sm="12" xs="12" md="4" lg="4" xl="4">
              <label>Convertir a: </label>
              <select v-model="deslozar.a_unit" class="form-control">
                <option
                  v-for="(item, index) in units"
                  :key="index"
                  :value="item"
                >
                  {{ item.name }}
                </option>
              </select>
            </CCol>
          </CRow>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            Cerrar
          </button>
          <button type="button" class="btn btn-primary" @click="mtdCommitDeslozar">
            Deslozar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deslozar: {
        a_unit: [],
        quantity: 0,
      },
      valid:true
    };
  },
  props: {
    units: {
      type: Array,
      required: true,
    },
    boo_modal: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    stock: {
      type: Object,
      default: {},
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    mtdValidStock: function () {
        if (parseFloat(this.deslozar.quantity) > parseFloat(this.stock.stock)) {
            this.valid = false;
        }else{
            this.valid = true;
        }
    },
    mtdCommitDeslozar: function (payload) {
      this.$emit("mtdCommitDeslozar", this.deslozar);
    }
  },
};
</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.table-responsive {
  overflow-x: auto;
  white-space: nowrap;
}
</style>